import moment from 'moment'

import { Message } from '../../models/Message'

export function getUpdatedInbox(inbox: Message[], message: Message, isGroup?: boolean): Message[] {
    let updatedInbox = [...inbox]

    const inboxIndex = updatedInbox.findIndex((m) =>
        isGroup ? m.team?.id === message.team?.id : m.person?.id === message.person?.id
    )

    if (inboxIndex !== -1) updatedInbox.splice(inboxIndex, 1)
    updatedInbox.unshift(message)

    return updatedInbox.sort((a, b) => moment(b.createdDate).diff(moment(a.createdDate)))
}
